import { cn } from "@/lib/utils";

interface StatusItem {
  status: string;
  count: number;
}

interface DashboardStatusBreakdownProps {
  items: StatusItem[];
  maxCount: number;
}

const STATUS_LABELS: Record<string, string> = {
  new: "Nova",
  processing: "U obradi",
  fulfilled: "Isporučena",
  cancelled: "Otkazana",
};

const STATUS_COLORS: Record<string, string> = {
  new: "bg-blue-500",
  processing: "bg-amber-500",
  fulfilled: "bg-emerald-500",
  cancelled: "bg-red-500",
};

export default function DashboardStatusBreakdown({ items, maxCount }: DashboardStatusBreakdownProps) {
  return (
    <div className="bg-white rounded-xl border border-border/60 p-5">
      <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        Status narudžbi
      </p>
      <div className="space-y-3">
        {items.map((item) => {
          const widthPct = (item.count / maxCount) * 100;
          const colorClass = STATUS_COLORS[item.status] ?? "bg-foreground/40";
          const label = STATUS_LABELS[item.status] ?? item.status;
          return (
            <div key={item.status} className="flex items-center gap-3">
              <span className={cn("size-2.5 rounded-full shrink-0", colorClass)} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium">{label}</span>
                  <span className="text-sm tabular-nums text-muted-foreground">
                    {item.count}
                  </span>
                </div>
                <div className="h-1.5 bg-muted rounded-full overflow-hidden">
                  <div
                    className={cn("h-full rounded-full transition-all", colorClass)}
                    style={{ width: `${widthPct}%` }}
                  />
                </div>
              </div>
            </div>
          );
        })}
        {items.length === 0 && (
          <p className="text-sm text-muted-foreground">Nema podataka</p>
        )}
      </div>
    </div>
  );
}
